<mat-form-field *transloco="let t; read: 'configurations.tags'" class="tag-editor__tags">
  <mat-label
    >{{ t('tags') }}
    @if (showCount()) {
      ({{ configurationTags?.length || 0 }})
    }
  </mat-label>

  <mat-chip-grid #tagChipList aria-label="tags" [disabled]="!editable()">
    @for (route of configuration()?.config_routes; track route) {
      <mat-chip-row></mat-chip-row>
      <app-lex-xi-tag
        type="auto-generated"
        icon="ab_testing"
        [text]="route.config_route_name"
      ></app-lex-xi-tag>
    }
    @if (hasEieTag) {
      <mat-chip-row></mat-chip-row>
      <app-lex-xi-tag
        type="auto-generated"
        icon="app_textAnalytics"
        [text]="eieTagText"
        [tooltip]="eieTagTooltipText"
      ></app-lex-xi-tag>
    }
    @for (tag of configurationTags; track tag; let i = $index) {
      <mat-chip-row></mat-chip-row>
      <app-lex-xi-tag
        type="user"
        [text]="tag"
        [canUserDelete]="removable()"
        (onClick)="removeTag(i)"
      ></app-lex-xi-tag>
    }
    @if (!configuration()?.removed) {
      <input
        [formControl]="newChipInput"
        [value]="tagValue"
        [placeholder]="tagPlaceholder"
        [matChipInputFor]="tagChipList"
        [matChipInputSeparatorKeyCodes]="tagSeparatorKeysCodes"
        (matChipInputTokenEnd)="addTag($event)"
        (keydown.tab)="$event.preventDefault()"
      />
    }
  </mat-chip-grid>

  <mat-error>{{ error }}</mat-error>
</mat-form-field>
